<template>
  <div class="situation-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <staticChiose :halsYg="1" @SearchInfo="SearchInfo"/>
        <el-button type="primary" class="margin-bottom-sm" @click="repairDialog = true" v-if="user.power === 6">添加报修</el-button>
      </div>
      <div class="reform-box flex align-center " v-if="allNumber">
        <div class="reform-left">
          <img src="../../assets/img/reform-icon.png" alt="">
          <h3>报修情况</h3>
        </div>
        <div class="flex align-center justify-around reform-right">
          <div>
            <p>总报修数量</p>
            <h3>{{ allNumber.all.totle }}</h3>
          </div>
          <div>
            <p>已完成报修</p>
            <h3>{{ allNumber.all.ok }}</h3>
          </div>
          <div>
            <p>完成占比</p>
            <h3>{{ allNumber.all.oklv }}</h3>
          </div>
          <div>
            <p>处理中报修</p>
            <h3>{{ allNumber.all.no }}</h3>
          </div>
          <div>
            <p>处理占比</p>
            <h3>{{ allNumber.all.nolv }}</h3>
          </div>
          <div>
            <p>已取消</p>
            <h3>{{ allNumber.all.del }}</h3>
          </div>
          <div>
            <p>取消占比</p>
            <h3>{{ allNumber.all.dellv }}</h3>
          </div>
        </div>
      </div>
      <div class="flex align-center justify-between flex-wrap margin-top-sm" v-if="allNumber">
        <div class="poll-item">
          <div class="item-title active5"><span><img src="../../assets/img/my5.png" alt="">漏水</span> <b>{{ allNumber.type1.total }}</b></div>
          <div class="item-info">
            <div class="item-num">
              <p>状态</p>
            </div>
            <i></i>
            <div class="item-num">
              <p>数量</p>
            </div>
            <i></i>
            <div class="item-num">
              <p>比例</p>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>处理中</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #00a0e9">{{ allNumber.type1.no }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #00a0e9">{{ allNumber.type1.nolv }}</h3>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>已完成</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #52b72f">{{ allNumber.type1.ok }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #52b72f">{{ allNumber.type1.oklv }}</h3>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>已取消</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #e92f2f">{{ allNumber.type1.del }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #e92f2f">{{ allNumber.type1.dellv }}</h3>
            </div>
          </div>
        </div>
        <div class="poll-item">
          <div class="item-title active6"><span><img src="../../assets/img/my6.png" alt="">停电</span> <b>{{ allNumber.type2.total }}</b></div>
          <div class="item-info">
            <div class="item-num">
              <p>状态</p>
            </div>
            <i></i>
            <div class="item-num">
              <p>数量</p>
            </div>
            <i></i>
            <div class="item-num">
              <p>比例</p>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>处理中</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #00a0e9">{{ allNumber.type2.no }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #00a0e9">{{ allNumber.type2.nolv }}</h3>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>已完成</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #52b72f">{{ allNumber.type2.ok }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #52b72f">{{ allNumber.type2.oklv }}</h3>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>已取消</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #e92f2f">{{ allNumber.type2.del }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #e92f2f">{{ allNumber.type2.dellv }}</h3>
            </div>
          </div>
        </div>
        <div class="poll-item">
          <div class="item-title active7"><span><img src="../../assets/img/my7.png" alt="">电梯故障</span> <b>{{ allNumber.type3.total }}</b></div>
          <div class="item-info">
            <div class="item-num">
              <p>状态</p>
            </div>
            <i></i>
            <div class="item-num">
              <p>数量</p>
            </div>
            <i></i>
            <div class="item-num">
              <p>比例</p>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>处理中</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #00a0e9">{{ allNumber.type3.no }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #00a0e9">{{ allNumber.type3.nolv }}</h3>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>已完成</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #52b72f">{{ allNumber.type3.ok }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #52b72f">{{ allNumber.type3.oklv }}</h3>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>已取消</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #e92f2f">{{ allNumber.type3.del }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #e92f2f">{{ allNumber.type3.dellv }}</h3>
            </div>
          </div>
        </div>
        <div class="poll-item">
          <div class="item-title active8"><span><img src="../../assets/img/my8.png" alt="">门禁损坏</span> <b>{{ allNumber.type4.total }}</b></div>
          <div class="item-info">
            <div class="item-num">
              <p>状态</p>
            </div>
            <i></i>
            <div class="item-num">
              <p>数量</p>
            </div>
            <i></i>
            <div class="item-num">
              <p>比例</p>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>处理中</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #00a0e9">{{ allNumber.type4.no }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #00a0e9">{{ allNumber.type4.nolv }}</h3>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>已完成</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #52b72f">{{ allNumber.type4.ok }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #52b72f">{{ allNumber.type4.oklv }}</h3>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>已取消</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #e92f2f">{{ allNumber.type4.del }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #e92f2f">{{ allNumber.type4.dellv }}</h3>
            </div>
          </div>
        </div>
        <div class="poll-item">
          <div class="item-title active4"><span><img src="../../assets/img/my9.png" alt="">其他</span> <b>{{ allNumber.type5.total }}</b></div>
          <div class="item-info">
            <div class="item-num">
              <p>状态</p>
            </div>
            <i></i>
            <div class="item-num">
              <p>数量</p>
            </div>
            <i></i>
            <div class="item-num">
              <p>比例</p>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>处理中</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #00a0e9">{{ allNumber.type5.no }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #00a0e9">{{ allNumber.type5.nolv }}</h3>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>已完成</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #52b72f">{{ allNumber.type5.ok }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #52b72f">{{ allNumber.type5.oklv }}</h3>
            </div>
          </div>
          <div class="item-info">
            <div class="item-num">
              <p>已取消</p>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #e92f2f">{{ allNumber.type5.del }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <h3 style="color: #e92f2f">{{ allNumber.type5.dellv }}</h3>
            </div>
          </div>
        </div>
      </div>
      <el-table
        :data="situationList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
        <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
        <el-table-column label="楼门户">
          <template slot-scope="scope">
            <div>
              {{ scope.row.building_name }}-{{ scope.row.element_name }}-{{ scope.row.room_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="负责人">
          <template slot-scope="scope">
            <div>
              {{ scope.row.fuzeren }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="户主姓名" prop="name"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="报修类型" prop="state">
          <template slot-scope="scope">
            <div>
              {{ scope.row.type | type }} <span v-if="scope.row.type === 5">({{ scope.row.baoxiu_content}})</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="update_time"></el-table-column>
        <el-table-column label="完成状态" prop="type">
          <template slot-scope="scope">
            <div>
<!--              {{ scope.row.state | state }}-->
              <el-select v-model="scope.row.state" placeholder="请选择" @change="setStatus(scope.$index)">
                <el-option
                  v-for="item in wanchengList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" >
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                size="small"
                type="primary"
                @click="deleteItem(scope.row.id)"
              >删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="situationList.length > 0"
        class="page-all"
        background
        @current-change="getResidentList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <repairDialog :repairDialog="repairDialog" @cancelDialog="cancelDialog"/>
    </div>
  </div>
</template>

<script>
import staticChiose from "@/components/static-chiose";
import repairDialog from "@/views/pages/dialog/repairDialog";
import {changeBaoXiuStatus, delBaoXiu, getBaoXiuList, getBaoXiuShuJu} from "@/api/property";
import {baoxiuList, filesCN, optionList, wanchengList, zhDate} from "@/utils/utils";

export default {
  name: "property-repair",
  data() {
    return {
      project: 0,
      community: 0,
      yuangong: 0,
      wancheng: 0,
      baoxiu: 0,
      dateArr: null,
      page: 1,
      limit: 10,
      total: 0,
      situationList: [],
      allNumber:null,
      repairDialog: false,
      wanchengList:optionList(0,wanchengList)
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", this.$route.path, "报修情况", false);
    this.SearchInfo
  },
  components: {
    staticChiose,
    repairDialog
  },
  methods: {
    //  删除社区
    deleteItem(id) {
      this.$confirm('您确定要删除该报修记录吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await delBaoXiu(id);
      if (this.situationList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.SearchInfo();
      this.$message.success(_state.info);
    },

    //  修改状态
    async setStatus(index){
      let _state = await changeBaoXiuStatus(this.situationList[index].id,this.situationList[index].state)
      this.$message.success(_state.info)
    },


    async SearchInfo(val) {
      if(val){
        this.project = val.project
        this.community = val.community
        this.yuangong = val.yuangong
        this.wancheng = val.wancheng
        this.baoxiu = val.baoxiu
        this.dateArr = val.dateArr
        this.page = 1
      }

      await this.getResidentList()
      await this.getBaoXiuShuJu()
    },
    async getResidentList() {
      let _data = await getBaoXiuList(
        this.project,
        this.community,
        this.yuangong,
        this.wancheng,
        this.baoxiu,
        1,
        this.dateArr ? zhDate(this.dateArr[0]) + ' 00:00:00' : '',
        this.dateArr ? zhDate(this.dateArr[1]) + ' 23:59:59' : '',
        this.page,
        this.limit
      )
      this.situationList = _data.data
      this.total = _data.total_number
    },
    async getBaoXiuShuJu() {
      let _data = await getBaoXiuShuJu(
        this.project,
        this.community,
        this.yuangong,
        this.wancheng,
        this.baoxiu,
        1,
        this.dateArr ? zhDate(this.dateArr[0]) + ' 00:00:00' : '',
        this.dateArr ? zhDate(this.dateArr[1]) + ' 23:59:59' : ''
      )
      this.allNumber = _data.data
    },
    cancelDialog() {
      this.repairDialog = false
      this.getResidentList()
      this.getBaoXiuShuJu()
    }
  },
  filters: {
    type(val) {
      return filesCN(val, baoxiuList)
    }
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.reform-box {
  width: 100%;
  height: 162px;
  padding: 20px 0;
  border-radius: 8px;
  background: url(../../assets/img/reform-bg.png) no-repeat;
  background-size: 100% 100%;

  &.active {
    background: url(../../assets/img/reform-bg2.png) no-repeat;
    background-size: 100% 100%;
  }

  .reform-left {
    width: 320px;
    height: 129px;
    padding: 20px 0;
    border-right: 1px solid #fff;

    img {
      display: block;
      margin: 0 auto 15px;
    }

    h3 {
      text-align: center;
      color: #fff;
      font-size: 20px;
    }
  }

  .reform-right {
    flex: 1;
    color: #fff;

    p {
      font-size: 16px;
      line-height: 24px;
    }

    h3 {
      font-size: 35px;
      line-height: 45px;
    }
  }
}

.poll-item {
  flex-basis: 19%;
  height: 210px;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 19px 0px rgba(175, 181, 193, 0.47);
  border-radius: 8px;
  padding-bottom: 10px;

  .item-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 40px;
    font-size: 18px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    &.active1 {
      background-color: #1bb2cd;
    }

    &.active2 {
      background-color: #ffaf25;
    }

    &.active3 {
      background-color: #42922a;
    }

    &.active4 {
      background-color: #616161;
    }

    &.active5 {
      background-color: #1bb2cd;
    }

    &.active6 {
      background-color: #bf984c;
    }

    &.active7 {
      background-color: #2587ff;
    }

    &.active8 {
      background-color: #e15757;
    }

    img {
      margin-right: 10px;
    }

    b {
      font-size: 20px;
      color: #fff;
      float: right;
    }
  }

  .item-info {
    display: flex;
    align-items: center;
    height: 40px;
    line-height: 40px;

    &.total-all {
      justify-content: center;
      font-size: 16px;

      b {
        font-size: 32px;
        margin-right: 5px;
      }
    }

    .item-num {
      width: 48%;
      height: 40px;
      line-height: 40px;
      text-align: center;

      p {
        font-size: 14px;
        color: #999;
      }

      h3 {
        font-size: 22px;
      }
    }

    i {
      display: block;
      width: 1px;
      height: 20px;
      border: dashed 1px #cccccc;
      opacity: 0.5;
    }
  }
}
</style>
